import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Mail = createReactComponent("Mail", ["svg", defaultAttributes, [["path", {
  d: "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z",
  key: "1oqfcz"
}], ["polyline", {
  points: "22,6 12,13 2,6",
  key: "1y3j1y"
}]]]);
export default Mail;